<div class="grid-filter-text">
  <input kendoTextBox [type]="'text'" (keydown)="onKeyDown($event)" (focus)="onFocus($event)" (blur)="onBlur($event)"  [(ngModel)]="value"/>  
</div>

<kendo-grid-filter-cell-operators [value]="operator" [operators]="customOperators" [showButton]="hasFilters"
  (clear)="clearFilter(true)" (valueChange)="operatorChange($event)">
</kendo-grid-filter-cell-operators>
